import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmationDialog extends Vue {
  @Prop({ default: 'Confirmation' }) title: string;
  @Prop({ default: 'Are you sure you want to cancel this actions?' }) content: string;
  @Prop({ default: 'Cancel' }) cancelAction: string;
  @Prop({ default: 'Confirm' }) confirmAction: string;

  onConfirmChange(): void {
    this.$emit('onConfirmChanged', true);
  }

  onCancelChange(): void {
    this.$emit('onCancelChanged', true);
  }
}
